import { createFileRoute } from '@tanstack/react-router'
import { ListIndex } from '@/features/lists/ListIndex'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/lists/')({
  component: ListsPage,
})

function ListsPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Lists" meta="Where tasks live" />
      <div className="mt-6">
        <ListIndex />
      </div>
    </div>
  )
}
